import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationValuationBlockConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationValuationBlock";
    static FUNCTION_DELETE_MULTIPLE_VALUATION_BLOCKS = "DeleteMultipleValuationBlocks";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetValuationBlockSetAllValuers";
    static FUNCTION_IMPORT_PV_BLOCK_DATA = "ImportValuationBlockPVData";
    static FUNCTION_SET_VALUATION_BLOCK_PARAMETER = "SetValuationBlockParameter";
    static FUNCTION_SET_HYBRID_METHODS = "SetHybridMethods";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetPropertyValuationValuationRequiredDocumentsChecklist";
    static FUNCTION_GET_ASSISTANT_VALUERS = "RetrieveAssistantValuers";
    static FUNCTION_GET_DATA_COLLECTORS = "RetrieveDataCollectors";
    static FUNCTION_SET_VALUATION_BLOCK_PROPERTIES_PROPERTIES = "SetValuationBlockPropertiesProperties";
    static FUNCTION_SET_SALES_AREA = "SetSalesArea";
    static FUNCTION_GENERATE_SECTION_49_NOTICES = "GenerateSection49Notices";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
}
